<template>
  <div id="adjustment-root">
    <!-- <vs-tabs ref="flowtabs"> 
      <vs-tab label="Ajustes Gerais" icon="settings" v-if="canSee('configs-dynamic-settings')"> -->
        <div class="flex flex-direction-column flex justify-center mb-8 items-center">
          <!-- <div class="w-full">
            <div class="flex flex-direction-column w-full mt-8 justify-center items-center">
              <span class="mb-2">Número de Celular para Notificações</span>
              <vs-input
                v-model="notificationsPhoneNumber"
                v-mask="['(##) ####-####', '(##) #####-####']"
              ></vs-input>
            </div>
          </div> -->
          <vs-row>
            <vs-col vs-type="flex">
              <vs-card>
                <div slot="header">
                  <h4>
                    <div class="w-full flex flex-direction-row justify-left items-center">
                      <span class="ml-0 mr-2">Unificar Conexões</span>
                      <vs-switch v-model="unifyConnections"/>
                      <vx-tooltip
                        delay=".2s"
                        class="mt-2"
                        color="gray"
                        id="tooltip"
                        position="bottom"
                        text="Essa funcionalidade permite que seja possível unificar, sem restrições, todas as conexões disponíveis na plataforma. Sendo possível conversar com múltiplos números a partir de uma única visualização."
                      >
                        <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                      </vx-tooltip>
                    </div>
                  </h4>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-type="flex">
              <vs-card>
                <div slot="header">
                    <h5> 
                      <div class="w-full">
                        <div class="flex flex-direction-row w-full justify-left items-center">
                          <span class="ml-0 mr-2">Distribuição Automática</span>
                          <vs-switch v-model="relateChatTicketsToNextUser"/>
                          <span class="ml-2 mr-2">Caixa de Entrada</span>      
                          <vx-tooltip
                            class="mt-2"
                            id="tooltip"
                            position="bottom"
                            color="gray"
                            text="*Caixa de entrada: Aba no chat que agrupa todos os atendimentos que ainda não foram iniciados, proporcionando mais organização e facilidade. Os atendentes disponíveis acessam a caixa de entrada para pegar os atendimentos assim diminuindo o tempo que os clientes esperam por uma resposta, especialmente se a função de Fila Inteligente (atender mais antigos) for utilizada.
                                  *Distribuição Automática: Distribui automaticamente os atendimentos para todos os atendentes online, em ordem. Nesta função, quando não há atendentes online, os atendimentos serão agrupados no usuário administrador. Exige mais atenção dos atendentes."
                            delay=".2s"
                          >
                            <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                          </vx-tooltip>
                        </div>
                      </div>
                    </h5>
                </div>

  
                <!-- flex flex-direction-column w-full mt-8 justify-center items-left -->
                <div class="w-full" v-if="relateChatTicketsToNextUser === true">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="olderInboxChatsFirstOnly">
                      <span class="">Fila Inteligente (atendimentos ordenados por tempo de espera)</span>
                    </vs-checkbox>
                  </div>
                </div>
                
                <div class="w-full" v-if="relateChatTicketsToNextUser === true && olderInboxChatsFirstOnly === true">
                  <div
                    class="con-vs-checkbox w-full mt-4 items-center"
                  >
                    <vs-checkbox v-model="olderInboxChatsObligatorieInFirst">
                      <span class="">Fila Ordenada Obrigatória (obrigatório atender mais antigos primeiro)</span>
                    </vs-checkbox>
                  </div>
                </div>

                <div class="w-full" v-if="relateChatTicketsToNextUser === true">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="limitChatTicketsActivated">
                      <span class="">
                        Limites de Atendimentos Simultâneos
                      </span>
                    </vs-checkbox>
                    <div 
                    class="con-vs-checkbox items-center"
                    v-if="relateChatTicketsToNextUser === true && limitChatTicketsActivated === true">
                      <vs-input-number class="m-0 ml-2" :min="1" :max="100" v-model="limitChatTickets"></vs-input-number>
                    </div>
                  </div>
                </div>

                <!--                <div class="w-full" v-if="relateChatTicketsToNextUser === false">
                  <div class="con-vs-checkbox w-full mt-1 items-center">
                    <vx-tooltip
                      class="ml-2 mt-2"
                      position="bottom"
                      color="warning"
                      text="Por recomendações do Whatsapp nós bloqueamos os disparos para no máximo 2 mensagens por minuto até a finalização das eleições brasileiras no dia 01/11/2022. Relembrando que qualquer disparo relacionado a campanha política pelo PedBot será automaticamente enviada uma denúncia ao Ministério Público e TSE."
                      delay=".3s"
                    >
                      <feather-icon icon="AlertTriangleIcon" svgClasses="w-7 h-7 text-warning"></feather-icon>
                    </vx-tooltip>
                    <span class="ml-1">Mensagens Disparadas por Minuto</span>
                     <vs-input-number min="1" v-model="spamIntervalMinutes"></vs-input-number> Eleições
                  </div>
                </div>

                <div class="w-full" v-if="relateChatTicketsToNextUser === false">
                  <div class="con-vs-checkbox w-full mt-1 items-center">
                    <span class="ml-1">Tempo de Intervalo dos Disparos de Mensagens (em minutos)</span>
                     <vs-input-number min="1" v-model="spamIntervalMinutes"></vs-input-number> Eleições
                  </div>
                </div>
                
                <div class="w-full" v-if="relateChatTicketsToNextUser === false">
                  <div
                    v-if="redirectIdleAttendance"
                    class="flex flex-direction-column w-full mt-8 justify-center items-left"
                    >
                    <span>Tempo Máximo de Espera de Atendimento (em minutos)</span>
                    <vs-input-number :min="2" :max="30" v-model="redirectIdleMinutes"></vs-input-number>
                  </div>
                </div>
                  -->
              </vs-card>

              <vs-card v-if="mariaIsEnabled">
                <div slot="header">
                  <h4>
                    <div class="w-full">
                      <div class="flex flex-direction-row w-full justify-left items-center">
                        <span class="ml-0 mr-2"> Triagem Automática </span>
                        <vs-switch v-model="botIsActive"/>
                        <vx-tooltip
                        delay=".2s"
                        class="mt-2"
                        color="gray"
                        id="tooltip"
                        position="bottom"
                        text="Automatiza o processo de classificação e encaminhamento de solicitações de atendimento com base em critérios predefinidos, melhorando a eficiência e organização."
                        >
                          <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                        </vx-tooltip>
                      </div>
                    </div>
                  </h4>
                </div>
                
                <div class="w-full blue-button" v-if="botIsActive">
                  <div class="con-vs-checkbox w-full mt-2 items-center">
                
                    <span class="ml-1 mr-2 text-sm"> Bot de Triagem </span>
                    <vs-switch v-model="switchToNewPassiveFlow"/>
                    <span class="ml-2 mr-2 text-sm"> Mar.IA </span>
                    <vx-tooltip
                      v-if="alwaysSendNewPassiveFlow"
                      class="mt-2"
                      id="tooltip"
                      color="warning"
                      text="Ao ativar as opções da MarIA, o fluxo bot de triagem antigo será desativado, mas as mensagens do bot por horário de atendimento continuarão sendo enviados normalmente, sem atrapalhar o fluxo da MarIA e vice-versa!"
                      delay=".2s"
                    >
                      <feather-icon icon="InfoIcon" svgClasses="w-10 h-9 text-warning"/>
                    </vx-tooltip>
                  </div>
                </div>

                <div v-if="alwaysSendNewPassiveFlow">
                  <v-select
                    label="name" 
                    :options="mariaTypes"
                    :reduce="mariaTypes => mariaTypes.id"
                    v-model="mariaType"
                    class="select-maria-type"
                  />

                  <vs-checkbox class="mt-4" v-if="mariaType === 2" v-model="allowDeliveryOptionSaleFlow">
                    <span>
                      Habilitar Opções de Entrega e Endereço
                    </span>
                  </vs-checkbox>
                </div>

                <div class="w-full" v-if="botIsActive && alwaysSendPassiveFlow">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="priorityTicketsInPassiveFlow">
                      <span class="mb-2">Definir Prioridade em Atendimentos</span>
                    </vs-checkbox>
                    <vx-tooltip
                        class="mt-2"
                        id="tooltip"
                        position="right"
                        color="gray"
                        text="Habilitando esta função, seu bot poderá classificar atendimentos em Alta, Média e Baixa prioridade. Configure tudo facilmente no fluxo do bot. Organize seus atendimentos de forma eficiente e atenda às demandas com maior precisão."
                        delay=".2s"
                    >
                      <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                    </vx-tooltip>
                  </div>
                </div>

                <div class="w-full" v-if="botIsActive && alwaysSendPassiveFlow && priorityTicketsInPassiveFlow">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="priorityWithoutPassiveFlow">
                      <span class="mb-2">Prioridade Automática para Atendimentos Sem Resposta do Bot</span>
                    </vs-checkbox>
                    <div class="con-vs-checkbox items-center">
                      <vs-input-number class="m-0 ml-2" :min="1" :max="9999" v-model="priorityWithoutPassiveFlowMinutes"/>
                      <span class="ml-4"> (Minutos) </span>
                    </div>
                    <vx-tooltip
                        class="mt-2"
                        id="tooltip"
                        position="right"
                        color="gray"
                        text="Ao habilitar esta nova função, seu bot poderá priorizar automaticamente os atendimentos que não receberam resposta após o envio da mensagem, após um período configurável. Assim, você garante que todos os clientes sejam atendidos em tempo hábil, mesmo que não tenham escolhido uma opção no bot."
                        delay=".2s"
                    >
                      <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                    </vx-tooltip>
                  </div>
                </div>

                <div class="w-full" v-if="botIsActive && alwaysSendPassiveFlow">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="alloySleepPassiveFlow">
                      <span class="mb-2">Separar Mensagens e Aguardar Interação do Cliente</span>
                    </vs-checkbox>
                    <vx-tooltip
                      class="mt-2"
                      id="tooltip"
                      position="right"
                      color="gray"
                      text="Com essa função habilitada as Mensagens de Interação do tipo 'texto' serão encaminhadas separadamente e também o Bot irá aguardar a resposta do contato para encaminhar o restante do fluxo."
                      delay=".2s"
                    >
                      <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                    </vx-tooltip>
                  </div>
                </div>
                
                <div class="w-full" v-if="botIsActive && alwaysSendPassiveFlow">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="replyCustomerChatOptionChoose">
                      <span class="mb-2">Responder o Cliente Com a Opção Selecionada</span>
                    </vs-checkbox>
                  </div>
                </div>
                
                <div class="w-full" v-if="botIsActive && alwaysSendPassiveFlow">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="enableBackOptionPassiveFlow">
                      <span class="mb-2">Habilitar Opção de Voltar para Opções Anteriores</span>
                    </vs-checkbox>
                    <vx-tooltip
                      class="mt-2"
                      id="tooltip"
                      position="right"
                      color="gray"
                      text='Habilita uma opção extra no fluxo do bot, que permite o cliente voltar para opções anteriores. O número dessa opção é "0", e sempe que o cliente escolher esse número as opções serão voltadas para o fluxo anterior do bot.'
                      delay=".2s"
                    >
                      <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                    </vx-tooltip>
                  </div>
                </div>
                
                <div class="w-full" v-if="botIsActive && alwaysSendPassiveFlow">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="sendMessageLGPDInFlow">
                      <span class="mb-2">Adicionar Mensagem Avisando o Cliente que o Robô é uma Automação</span>
                    </vs-checkbox>
                  </div>
                </div>

              </vs-card>

              <vs-card v-else>
                <div slot="header">
                  <h4>Bot de Conversas</h4>
                </div>
                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="alwaysSendPassiveFlow">
                      <span class="mb-2">Enviar Bot de Triagem Sempre que Iniciar um Atendimento</span>
                    </vs-checkbox>
                  </div>
                </div>

                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="priorityTicketsInPassiveFlow">
                      <span class="mb-2">Definir Prioridade em Atendimentos</span>
                    </vs-checkbox>
                    <vx-tooltip
                        class="mt-2"
                        id="tooltip"
                        position="right"
                        color="gray"
                        text="Habilitando esta função, seu bot poderá classificar atendimentos em Alta, Média e Baixa prioridade. Configure tudo facilmente no fluxo do bot. Organize seus atendimentos de forma eficiente e atenda às demandas com maior precisão."
                        delay=".2s"
                    >
                      <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                    </vx-tooltip>
                  </div>
                </div>

                <div class="w-full" v-if="priorityTicketsInPassiveFlow">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="priorityWithoutPassiveFlow">
                      <span class="mb-2">Prioridade Automática para Atendimentos Sem Resposta do Bot</span>
                    </vs-checkbox>
                    <div class="con-vs-checkbox items-center">
                      <vs-input-number class="m-0 ml-2" :min="1" :max="9999" v-model="priorityWithoutPassiveFlowMinutes"/>
                      <span class="ml-4"> (Minutos) </span>
                    </div>
                    <vx-tooltip
                        class="mt-2"
                        id="tooltip"
                        position="right"
                        color="gray"
                        text="Ao habilitar esta nova função, seu bot poderá priorizar automaticamente os atendimentos que não receberam resposta após o envio da mensagem, após um período configurável. Assim, você garante que todos os clientes sejam atendidos em tempo hábil, mesmo que não tenham escolhido uma opção no bot."
                        delay=".2s"
                    >
                      <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                    </vx-tooltip>
                  </div>
                </div>
              
                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="alloySleepPassiveFlow">
                      <span class="mb-2">Separar Mensagens e Aguardar Interação do Cliente</span>
                    </vs-checkbox>
                    <vx-tooltip
                      class="mt-2"
                      id="tooltip"
                      position="right"
                      color="gray"
                      text="Com essa função habilitada as Mensagens de Interação do tipo 'texto' serão encaminhadas separadamente e também o Bot irá aguardar a resposta do contato para encaminhar o restante do fluxo."
                      delay=".2s"
                    >
                      <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                    </vx-tooltip>
                  </div>
                </div>
              
                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="enableBackOptionPassiveFlow">
                      <span class="mb-2">Habilitar Opção de Voltar para Opções Anteriores</span>
                    </vs-checkbox>
                    <vx-tooltip
                      class="mt-2"
                      id="tooltip"
                      position="right"
                      color="gray"
                      text='Habilita uma opção extra no fluxo do bot, que permite o cliente voltar para opções anteriores. O número dessa opção é "0", e sempe que o cliente escolher esse número as opções serão voltadas para o fluxo anterior do bot.'
                      delay=".2s"
                    >
                      <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                    </vx-tooltip>
                  </div>
                </div>
              
                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="replyCustomerChatOptionChoose">
                      <span class="mb-2">Responder o Cliente Com a Opção Selecionada</span>
                    </vs-checkbox>
                  </div>
                </div>
              
                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="sendMessageLGPDInFlow">
                      <span class="mb-2">Adicionar Mensagem Avisando o Cliente que o Robô é uma Automação</span>
                    </vs-checkbox>
                  </div>
                </div>
              </vs-card>

            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-type="flex">
              <vs-card>
                <div slot="header" class="w-full flex flex-direction-row justify-left items-center"> 
                  <h4>Encerramentos Automáticos</h4>
                  <vx-tooltip
                      class="mt-2"
                      id="tooltip"
                      position="right"
                      color="gray"
                      text='Permite definir regras para o encerramento automático de atendimentos, por pesquisa de satisfacao ou pedidos após determinado período de inatividade, garantindo uma gestão eficaz do tempo.'
                      delay=".2s"
                    >
                    <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                  </vx-tooltip>
                </div>
                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="disconnectAllChatsAtMidnight">
                      <span class="mb-2">Todos os Atendimentos em Aberto às 00:00</span>
                    </vs-checkbox>
                  </div>
                </div>

                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="disconnectAllSearchAtMidnight">
                      <span class="mb-2">Todas as Pesquisas de Satisfação em Aberto às 00:00</span>
                    </vs-checkbox>
                  </div>
                </div>

                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="finishChatTicketsByInactivity">
                      <span class="mb-2">Encerrar Atendimento por Inatividade</span>
                    </vs-checkbox>
                  </div>
                </div>

                <div class="w-full" v-if="finishChatTicketsByInactivity">
                  <div class="con-vs-checkbox w-full mt-3 items-center">
                    <vs-checkbox disabled>
                      <span>Tempo de Inatividade para Encerramento</span>
                    </vs-checkbox>
                    <div class="con-vs-checkbox items-center">
                      <vs-input-number class="mr-4" :min="1" :max="currentMaxValue(selectedUnit)" v-model="finishChatTicketsByInactivityMinutes" @input="updateMaxValue(finishChatTicketsByInactivityMinutes, selectedUnit)"/>
                    </div>
                    <span class="mr-2">({{ selectedUnit }})</span>
                  </div>
                  <div class="con-vs-checkbox w-full m-0">
                    <vs-radio class="mt-4 ml-4 mr-2" v-model="selectedUnit" vs-name="selectedUnit" vs-value="Minutos" @change="updateMaxValue('finishChatTicketsByInactivityMinutes', selectedUnit)">Minutos</vs-radio>
                    <vs-radio class="mt-4 mr-2 mt-2" v-model="selectedUnit" vs-name="selectedUnit" vs-value="Horas" @change="updateMaxValue('finishChatTicketsByInactivityMinutes', selectedUnit)">Horas</vs-radio>
                    <vs-radio class="mt-4 mr-2 mt-2" v-model="selectedUnit" vs-name="selectedUnit" vs-value="Dias" @change="updateMaxValue('finishChatTicketsByInactivityMinutes', selectedUnit)">Dias</vs-radio>
                  </div>
                </div>

                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="finishChatTicketsByInboxInactivity">
                      <span class="mb-2">Contato para Atendimento por Inatividade na Caixa de Entrada</span>
                    </vs-checkbox>
                  </div>
                </div>

                <div class="w-full" v-if="finishChatTicketsByInboxInactivity">
                  <div class="con-vs-checkbox w-full mt-3 items-center">
                    <vs-checkbox disabled>
                      <span>Tempo de Inatividade para Contato por Inatividade na Caixa de Entrada</span>
                    </vs-checkbox>
                    <div class="con-vs-checkbox items-center">
                      <vs-input-number class="mr-4" :min="1" :max="currentMaxValue(inboxInactivitySelectUnit)" v-model="finishChatTicketsByInboxInactivityMinutes" @input="updateMaxValue(finishChatTicketsByInboxInactivityMinutes, inboxInactivitySelectUnit)"/>
                    </div>
                    <span class="mr-2">({{ inboxInactivitySelectUnit }})</span>
                  </div>
                  <div class="con-vs-checkbox w-full m-0">
                    <vs-radio class="mt-4 ml-4 mr-2" v-model="inboxInactivitySelectUnit" vs-name="inboxInactivitySelectUnit" vs-value="Minutos" @change="updateMaxValue('finishChatTicketsByInboxInactivityMinutes', inboxInactivitySelectUnit)">Minutos</vs-radio>
                    <vs-radio class="mt-4 mr-2 mt-2" v-model="inboxInactivitySelectUnit" vs-name="inboxInactivitySelectUnit" vs-value="Horas" @change="updateMaxValue('finishChatTicketsByInboxInactivityMinutes', inboxInactivitySelectUnit)">Horas</vs-radio>
                    <vs-radio class="mt-4 mr-2 mt-2" v-model="inboxInactivitySelectUnit" vs-name="inboxInactivitySelectUnit" vs-value="Dias" @change="updateMaxValue('finishChatTicketsByInboxInactivityMinutes', inboxInactivitySelectUnit)">Dias</vs-radio>
                  </div>
                </div>

                <div class="w-full" v-if="finishChatTicketsByInactivity">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="sendInactivityFollowUp">
                      <span class="mb-2">Aviso Prévio Sobre o Encerramento por Inatividade</span>
                    </vs-checkbox>
                    <vx-tooltip
                      class="mt-2"
                      id="tooltip"
                      position="right"
                      color="gray"
                      text='Quando essa opção for ativada será enviado ao cliente um aviso informando que o atendimento dele será encerrado por inatividade caso ele não responda. O aviso será enviado na metade do tempo em que foi configurado a opção de "Tempo de Inatividade para Encerramento", ou seja, caso o tempo configurado para o encerramento seja de 1 hora, o aviso será enviado 30 minutos antes do atendimento ser encerrado por inatividade.'
                      delay=".2s"
                    >
                      <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                    </vx-tooltip>
                  </div>
                </div>

                <div class="w-full" v-if="finishChatTicketsByInactivity && sendInactivityFollowUp">
                  <div class="con-vs-checkbox w-full mt-3 items-center">
                    <vs-checkbox disabled>
                      <span>Tempo de Inatividade para o Envio do Aviso Prévio</span>
                    </vs-checkbox>
                    <div class="con-vs-checkbox items-center">
                      <vs-input-number class="mr-4" :min="1" :max="currentMaxValue(inactivityFollowUpUnit)" v-model="inactivityFollowUpMinutes" @input="updateMaxValue(inactivityFollowUpMinutes, inactivityFollowUpUnit)"/>
                    </div>
                    <span class="mr-2">({{ inactivityFollowUpUnit }})</span>
                  </div>
                  <div class="con-vs-checkbox w-full m-0">
                    <vs-radio class="mt-4 ml-4 mr-2" v-model="inactivityFollowUpUnit" vs-name="inactivityFollowUpUnit" vs-value="Minutos" @change="updateMaxValue('inactivityFollowUpMinutes', inactivityFollowUpUnit)">Minutos</vs-radio>
                    <vs-radio class="mt-4 mr-2 mt-2" v-model="inactivityFollowUpUnit" vs-name="inactivityFollowUpUnit" vs-value="Horas" @change="updateMaxValue('inactivityFollowUpMinutes', inactivityFollowUpUnit)">Horas</vs-radio>
                    <vs-radio class="mt-4 mr-2 mt-2" v-model="inactivityFollowUpUnit" vs-name="inactivityFollowUpUnit" vs-value="Dias" @change="updateMaxValue('inactivityFollowUpMinutes', inactivityFollowUpUnit)">Dias</vs-radio>
                  </div>
                </div>
              </vs-card>

              <vs-card>
                <div slot="header" class="w-full flex flex-direction-row justify-left items-center"> 
                  <h4>Atendimento</h4>
                  <vx-tooltip
                        class="mt-2"
                        id="tooltip"
                        position="right"
                        color="gray"
                        text='Possibilidade de exibir o nome do atendente nas mensagens, definir um tempo de aceite para transferência, tornar obrigatória a pesquisa de atendimento e automatizar o envio diário de relatórios.'
                        delay=".2s"
                        >
                        <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                      </vx-tooltip>
                </div>

                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="showUsernameOnChat">
                      <span class="mb-2">Exibir Nome do Atendente na Mensagem</span>
                    </vs-checkbox>
                  </div>
                </div>

                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-3 items-center">
                    <vs-checkbox disabled>
                      <span>Tempo de Aceite para Transferencia</span>
                    </vs-checkbox>
                    <div class="con-vs-checkbox items-center">
                      <vs-input-number class="m-0 ml-2" :min="1" :max="10" v-model="requestTransferMinutes"/>
                        <span class="ml-4"> (Minutos) </span>
                    </div>
                  </div>
                </div>

                <div class="w-full">
                  <div
                    class="con-vs-checkbox w-full mt-3 items-center"
                  >
                  <vs-checkbox v-model="isMandatoryResearch">
                    <span class="mb-2">Pesquisa de Atendimento Obrigatória</span>
                  </vs-checkbox>
                  </div>
                </div>

                <div class="w-full">
                  <div
                    class="con-vs-checkbox w-full mt-3 items-center"
                  >
                    <vs-checkbox v-model="sendReportEveryDay">
                      <span class="mb-2">Envio Diário de Relatórios</span>
                    </vs-checkbox>
                    
                  </div>
                </div>

                <div class="grid grid-cols-1 sm:grid-cols-2 gap-4" v-if="sendReportEveryDay">
                  <span v-for="(email, index) in emails" :key="index" class=" ml-2 flex flex-col">
                    <div class="flex items-center">
                      <vs-input
                        class="mt-4 flex-1 mr-2"
                        v-model="emails[index]"
                        :name="`email-${index+1}`"
                        placeholder="E-mail de Destino"
                        v-validate="'required|email'"
                      />
                
                      <feather-icon
                        v-if="emails.length > 1"
                        @click="removeEmail(index)"
                        icon="XIcon" 
                        svgClasses="h-4 w-4 mt-3 cursor-pointer hover:text-danger"
                      />
                    </div>
                    
                    <div class="ml-2">
                      <span
                        class="text-danger text-sm"
                        v-show="errors.has(`email-${index+1}`)"
                      >
                        {{ errors.first(`email-${index+1}`) }}
                      </span>
                    </div>
                  </span>
                </div>
                

                <vs-button
                  v-if="sendReportEveryDay"
                  class="ml-2 mt-5" 
                  @click="emails.push('')" 
                  style="font-weight:500; border-radius:8px;" 
                  :style="emails.length > 1 ? 'padding-right: 3.7em;' : 'padding-right: 4.7em;'"
                  :disabled="emails.length === 16"
                >
                  + Adicionar e-mail
                </vs-button>
              </vs-card>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-type="flex">
              <vs-card>
                <div slot="header" class="w-full flex flex-direction-row justify-left items-center">
                  <h4>Pedidos</h4>
                  <vx-tooltip
                    class="mt-2"
                    id="tooltip"
                    position="right"
                    color="gray"
                    text='Oferece a capacidade de enviar notificações de atualizações de status aos clientes, além de permitir a remoção de opções de medicamentos nos produtos, especialmente útil para empresas que não são farmacêuticas.'
                    delay=".2s"
                    >
                    <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                  </vx-tooltip>         
                </div>
                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="sendOrderStatusNotification">
                      <span class="mb-2">Enviar Notificações de Atualização de Status dos Pedido ao Cliente</span>
                    </vs-checkbox>
                  </div>
                </div>
                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="enableNegativeStock">
                      <span class="mb-2">Habilitar Venda de Estoque Negativo</span>
                    </vs-checkbox>
                  </div>
                </div>
                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="medicationsOptionsIsDisabled">
                      <span class="mb-2">Remover Opções de Medicamentos nos Produtos</span> 
                    </vs-checkbox>
                    <span>
                      <vx-tooltip
                        id="tooltip"
                        position="right"
                        color="warning"
                        text="ATENÇÃO: Essa opção serve apenas para empresas que NÃO SÃO FARMÁCIAS, ou seja, caso você NÃO seja uma farmácia 
                          e deseja que os seus produtos NÃO TENHAM OPÇÕES DE MEDICAMENTOS OU DE CUNHO FARMACÊUTICO recomendamos que habilite essa opção."
                        delay=".2s"
                      >
                        <feather-icon icon="AlertTriangleIcon" svgClasses="w-7 h-7 text-warning"></feather-icon>
                      </vx-tooltip>
                    </span>
                  </div>
                </div>
              </vs-card>
              <vs-card>
                <div slot="header" class="flex flex-direction-row w-full justify-left items-center"> 
                  <h4>Usuários</h4>
                  <vx-tooltip
                    class="mt-2"
                    id="tooltip"
                    position="right"
                    color="gray"
                    text='Estabelece um limite de tempo para a validação das senhas dos usuários, promovendo a segurança dos dados e o cumprimento das políticas de segurança.'
                    delay=".2s"
                    >
                    <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                  </vx-tooltip>
                </div>
                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="expirationPassword">
                      <span class="mb-2">Tempo Limite para Expiração de Senha da Plataforma Ajuste Programado</span>
                    </vs-checkbox>
                  </div>
                </div>
                <div class="align-input-date-time" v-if="expirationPassword">
                  <div class="custom-select">
                    <select id="period" v-model="selected" @change="calculateNewDate" style="color: #333;" class="w-64 sm:w-32 md:w-48 lg:w-64">
                      <option value="" disabled></option>
                      <option v-for="item in options" :value="item.value">{{ item.text }}</option>
                    </select>
                  </div>
                </div>
                <div v-if="expirationPassword">
                  <span style="position: relative; display: flex; align-items: center;">
                    <vs-input
                      style="margin-bottom: 10px; margin-top: 11px; margin-left: 11px;"
                      class="w-64 sm:w-32 md:w-48 lg:w-64"
                      :value="formattedDate"
                      name="expirationDate"
                      placeholder="Data da Expiração"
                      v-validate="'required|email'"
                    />
                    <vx-tooltip
                      class="mt-2"
                      id="tooltip"
                      position="right"
                      color="grey"
                      text="Data de Expiração da senha"
                      delay=".2s"
                      style="margin-top: 20px; margin-left: 5px;"
                    >
                      <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                    </vx-tooltip>
                  </span>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>

          <vs-row>
            <vs-col vs-type="flex">
              <vs-card>
                <div slot="header" class="flex flex-direction-row w-full justify-left items-center">
                  <h4>Campanhas</h4>
                  <vx-tooltip
                    class="mt-2"
                    id="tooltip"
                    position="right"
                    color="gray"
                    text='Oferece a capacidade de criar e gerenciar campanhas de marketing ou promoções diretamente na plataforma, facilitando o engajamento e a comunicação com os clientes. Além de possibilitar o reenvio de SMS e e-mail para os clientes.'
                    delay=".2s"
                    >
                    <feather-icon icon="HelpCircleIcon" svgClasses="w-10 h-9 text-grey"></feather-icon>
                  </vx-tooltip>
                </div>
                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="sendCampaignToAll">
                      <span class="text-sm mb-2">Enviar Campanhas para Contatos com Atendimento em Aberto</span>
                    </vs-checkbox>
                  </div>
                </div>

                <div class="w-full">
                  <div class="con-vs-checkbox w-full mt-4 items-center">
                    <vs-checkbox v-model="resendFailedDispatches">
                      <span class="text-sm"> Reenviar Disparos SMS e Email Falhados </span>
                    </vs-checkbox>
                  </div>
                </div>

                <div class="w-full" v-if="resendFailedDispatches">
                  <div class="con-vs-checkbox w-full mt-3 items-center">
                    <vs-checkbox disabled>
                      <span>Quantidade de Tentativas por Disparo a Cada 5 Minutos</span>
                    </vs-checkbox>
                    <div class="con-vs-checkbox items-center">
                      <vs-input-number class="m-0 ml-2" :min="1" :max="15" v-model="spamResendFailedDispatches"/>
                    </div>
                    <span>
                      <vx-tooltip
                        id="tooltip"
                        class="mt-3 ml-3"
                        position="right"
                        color="warning"
                        text="ATENÇÃO: O número configurado em 'Quantidade de Tentativas por Disparo a Cada 5 Minutos' inclui as tentativas após a primeira falha, ou seja, se o número configurado for 1, o disparo tentará ser reenviado mais uma vez além da primeira tentativa (2 vezes)."
                        delay=".2s"
                      >
                        <feather-icon icon="AlertTriangleIcon" svgClasses="w-7 h-7 text-warning"></feather-icon>
                      </vx-tooltip>
                    </span>
                  </div>
                </div>
              </vs-card>
            </vs-col>
          </vs-row>

        </div>
      
        <div class="w-full" v-if="canSee('configs-dynamic-settings-update')">
          <div class="flex flex-direction-column w-full mt-8 justify-end items-end">
            <vs-button
              type="filled"
              class="align-right"
              :disabled="errors.has('email')"
              @click.prevent="saveSettings"
            >
              <span>Salvar</span>
            </vs-button>
          </div>
        </div>

        <MariaInfos
          :isActive="infosIsActive"
          @isActiveFalse="infosIsActive = false"
        />

  </div>
</template>

<script>
  //import Messages from '@/views/messages/Settings'
  //import MessageTemplate from '@/views/messages/MessageTemplate'
  import MariaInfos from '../new-chat-flows/infos/PopupInfos.vue';
  import { hasPermission, hasFeature } from '@/utils';
  import moduleSettings from '@/store/settings/moduleSettings';
  import flatPickr from 'vue-flatpickr-component';
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import 'flatpickr/dist/flatpickr.css';
  import vSelect from 'vue-select';

  export default {
    name: 'configs-dynamic-settings',
    components: {
      flatPickr,
     //Messages,
      //MessageTemplate
      MariaInfos,
      vSelect
    },
    data() {
      return {
        notificationsPhoneNumber: '',
        selectedUnit: 'Minutos',
        inboxInactivitySelectUnit: 'Minutos',
        spamIntervalMessages: 2,
        spamIntervalMinutes: 1,
        spamIntervalLimit: 150,
        // useChatFlow: false,
        sendCampaignToAll: false,
        blockCustomersAllInstances: false,
        redirectIdleMinutes: 2,
        requestTransferMinutes: 1,
        redirectIdleAttendance: false,
        alwaysSendPassiveFlow: false,
        alloySleepPassiveFlow: false,
        priorityTicketsInPassiveFlow: false,
        enableBackOptionPassiveFlow: false,
        replyCustomerChatOptionChoose: true,
        sendMessageLGPDInFlow: false,
        disconnectAllChatsAtMidnight: false,
        disconnectAllSearchAtMidnight: false,
        finishChatTicketsByInactivity: false,
        finishChatTicketsByInactivityMinutes: 1,
        finishChatTicketsByInboxInactivity: false,
        finishChatTicketsByInboxInactivityMinutes: 1,
        isMandatoryResearch: false,
        showUsernameOnChat: false,
        unifyConnections: false,
        relateChatTicketsToNextUser: false,
        olderInboxChatsFirstOnly: false,
        olderInboxChatsObligatorieInFirst: false,
        limitChatTicketsActivated: false,
        sendReportEveryDay: false,
        sendOrderStatusNotification: false,
        limitChatTickets: 0,
        emails: [''],
        medicationsOptionsIsDisabled: false,
        alwaysSendNewPassiveFlow: false,
        botIsActive: false,
        switchToNewPassiveFlow: null,
        mariaIsEnabled: false,
        infosIsActive: false,
        expirationPassword: false,
        date: '',
        time: '',
        configdateTimePicker: {
          enableTime: true,
          noCalendar: true,
          time_24hr: true
        },
        selected: '',
        expirationDate: null,
        options: [
          { text: '1 dia', value: '1' },
          { text: '7 dias', value: '7' },
          { text: '1 mês', value: '30' },
          { text: '3 meses', value: '90' },
          { text: '6 meses', value: '180' },
          { text: '1 ano', value: '365' }
        ],
        mariaType: null,
        sendTriageFlow: false,
        sendSaleFlow: false,
        resendFailedDispatches: false,
        spamResendFailedDispatches: 1,
        allowDeliveryOptionSaleFlow: false,
        sendInactivityFollowUp: false,
        inactivityFollowUpMinutes: 1,
        inactivityFollowUpUnit: 'Minutos',
        enableNegativeStock: false,
        priorityWithoutPassiveFlowMinutes: 10,
        priorityWithoutPassiveFlow: false
      }
    },
    computed: {
      settings() {
        return this.$store.state.settings.settings
      },
      formattedDate() {
        if (!this.date || this.date.trim() === '') {
          return 'DD/MM/AA';
        }

        const parts = this.date.split("-");
        if (parts.length !== 3) {
          return 'DD/MM/AA';
        }

        if(this.date === 'NaN-NaN-NaN'){
          return 'DD/MM/AA';
        }

        const formatted = `${parts[2]}/${parts[1]}/${parts[0]}`;
        return formatted;
      },
      mariaTypes() {
        return [
          {
            name: 'Fluxo Passivo',
            id: 1
          },
          {
            name: 'Fluxo de Vendas',
            id: 2
          }
        ]
      }
    },
    watch: {
      mariaType(value) {
        this.handleMariaType(value);
      },
      relateChatTicketsToNextUser(value) {

        this.handleStyle(
          document.querySelector( // Distribuição Automática
            `#content-area > div.content-wrapper > div > div > div.content-area__content > div:nth-child(2) 
            > div.flex.flex-direction-column.flex.justify-center.mb-8.items-center > div:nth-child(2) > div > div:nth-child(1)`
          ),
          document.querySelector( // Encerramentos Automáticos
            `#content-area > div.content-wrapper > div > div > div.content-area__content > div:nth-child(2) 
            > div.flex.flex-direction-column.flex.justify-center.mb-8.items-center > div:nth-child(3) > div > div:nth-child(1)`
          ),
          value
        );

      },
      olderInboxChatsFirstOnly(value){
        if (value === false ){
          this.olderInboxChatsObligatorieInFirst = false;
        }
      },
      botIsActive(value) {

        !value ? (
          [
            this.alwaysSendNewPassiveFlow,
            this.alwaysSendPassiveFlow,
            this.switchToNewPassiveFlow
          ] = [ false, false, null ]
        )
        : (
          this.alwaysSendNewPassiveFlow
          ? this.switchToNewPassiveFlow = true
          : this.switchToNewPassiveFlow = false
        );

        this.handleStyle(
          document.querySelector( // Triagem Automática
            `#adjustment-root > div.flex.flex-direction-column.flex.justify-center.mb-8.items-center 
            > div:nth-child(2) > div > div:nth-child(2)`
          ),
          document.querySelector( // Atendimento
            `#adjustment-root > div.flex.flex-direction-column.flex.justify-center.mb-8.items-center 
            > div:nth-child(3) > div > div:nth-child(2)`
          ),
          value
        );

      },
      switchToNewPassiveFlow(value) {

        if (value !== null && value && !this.mariaIsEnabled) {

          [
            this.infosIsActive,
            this.alwaysSendPassiveFlow,
            this.alwaysSendNewPassiveFlow,
            this.switchToNewPassiveFlow
          ] = [
            true,
            true,
            false,
            false
          ];

          return;

        }

        if (value !== null) {
          value ? (
            [
              this.alwaysSendNewPassiveFlow,
              this.alwaysSendPassiveFlow
            ] = [ true, false ]
          ) : (
            [
              this.alwaysSendNewPassiveFlow,
              this.alwaysSendPassiveFlow
            ] = [ false, true ]
          );
        }

      },
      alloySleepPassiveFlow(value){
        if (value) {
          this.sendMessageLGPDInFlow       = false;
          this.enableBackOptionPassiveFlow = false;
        }
      },
      enableBackOptionPassiveFlow(value) {
        if (value) {
          this.alloySleepPassiveFlow = false;
        }
      },
      sendMessageLGPDInFlow(value){
        if (value) {
          this.alloySleepPassiveFlow = false
        }
      }
    },
    methods: {
      currentMaxValue(unit) {
        const mappingMax = {
          'Horas': 23,
          'Dias': 7,
          'Minutos': 59
        };

        return mappingMax[unit];
      },
      updateMaxValue(minutes, unit) {
        if (this[minutes] > this.currentMaxValue(unit)) this[minutes] = this.currentMaxValue(unit);
      },
      hasDuplicateEmails() {
        let emailSet = new Set();
        let duplicates = new Set();

        this.emails.forEach(email => {
          if (emailSet.has(email)) {
              duplicates.add(email);
          } else {
              emailSet.add(email);
          }
        });

        return duplicates.size > 0;
      },
      validator() {
        if (this.hasDuplicateEmails()) { 
          return this.$vs.notify({
            color: 'danger',
            title: 'Atenção!',
            text: "Há e-mails duplicados, verifique os e-mails, por favor."
          })
        }
        if (!this.redirectIdleAttendance || this.relateChatTicketsToNextUser) {
            this.redirectIdleMinutes = 0
        }

        let emailValidation = this.emails.some(value => {
          return value.trim() === '' || value.length <= 3;
        });

        if (this.sendReportEveryDay && emailValidation) {
          return this.$vs.notify({
            color: 'danger',
            title: 'Ocorreu um erro ao salvar as configurações!',
            text: "Confira se o campo 'E-mail de Destino' foi preenchido corretamente."
          })
        }

        return true;
      },
      saveSettings() {
        this.calculateNewDate();
        if (!this.validator()) { return; }
        if (this.expirationPassword === false) { this.date = ' '; this.time = ' '; }
        if (
          this.sendInactivityFollowUp &&
          this.finishChatTicketsByInactivity &&
          this.convertUnits(this.inactivityFollowUpMinutes, this.inactivityFollowUpUnit) >=
          this.convertUnits(this.finishChatTicketsByInactivityMinutes, this.selectedUnit)
        ) {
          return this.$vs.notify({
            color: 'danger',
            title: 'Aviso:',
            text: 'O tempo configurado em "Tempo de Inatividade para o Envio do Aviso Prévio" é maior ou igual ao tempo de "Inatividade para Encerramento"!',
            time: 10000
          });
        }

        if (this.expirationPassword === true && this.selected === '' || this.selected === null) {
          return this.$vs.notify({
            color: 'danger',
            title: 'Ocorreu um erro ao salvar as configurações!',
            text: "Confira se os campos 'Data de Expiração' foram preenchidos corretamente."
          });
        }

        if (this.finishChatTicketsByInactivity) {
          this.$vs.notify({
            time: 10000,
            title: 'Atenção!',
            text: `Confira se a 'Mensagem de Inatividade' na aba de Robôs está configurado para ${this.selectedUnit}.`
          });
        }

        this.$store.dispatch("settings/update", {
          spam_interval_messages: this.spamIntervalMessages,
          spam_interval_minutes: this.spamIntervalMinutes,
          spam_interval_limit: this.spamIntervalLimit,
          // use_chat_flow: this.useChatFlow,
          notifications_phone_number: this.notificationsPhoneNumber,
          send_campaign_to_all: this.sendCampaignToAll,
          resend_failed_dispatches: this.resendFailedDispatches,
          spam_resend_failed_dispatches: this.spamResendFailedDispatches,
          block_customers_all_instances: this.blockCustomersAllInstances,
          redirect_idle_minutes: this.redirectIdleMinutes,
          request_transfer_minutes: this.requestTransferMinutes,
          always_send_passive_flow: this.alwaysSendPassiveFlow,
          alloy_sleep_passive_flow: this.alloySleepPassiveFlow,
          enable_back_option_passive_flow: this.enableBackOptionPassiveFlow,
          priority_tickets_in_passive_flow: this.priorityTicketsInPassiveFlow,
          priority_without_passive_flow: this.priorityWithoutPassiveFlow,
          priority_without_passive_flow_minutes: this.priorityWithoutPassiveFlowMinutes,
          reply_customer_chat_option_choose: this.replyCustomerChatOptionChoose,
          send_message_LGPD_in_flow: this.sendMessageLGPDInFlow,
          disconnect_all_chats_at_midnight: this.disconnectAllChatsAtMidnight,
          disconnect_all_search_at_midnight: this.disconnectAllSearchAtMidnight,
          finish_chat_tickets_by_inactivity: this.finishChatTicketsByInactivity,
          finish_chat_tickets_by_inactivity_minutes: this.convertUnits(this.finishChatTicketsByInactivityMinutes, this.selectedUnit),
          finish_chat_tickets_by_inactivity_unit: this.convertUnitToString(this.selectedUnit),
          finish_chat_tickets_by_inbox_inactivity: this.finishChatTicketsByInboxInactivity,
          finish_chat_tickets_by_inbox_inactivity_minutes: this.convertUnits(this.finishChatTicketsByInboxInactivityMinutes, this.inboxInactivitySelectUnit),
          finish_chat_tickets_by_inbox_inactivity_unit: this.convertUnitToString(this.inboxInactivitySelectUnit ? this.inboxInactivitySelectUnit : 'Minutos'),
          is_mandatory_research: this.isMandatoryResearch,
          send_inactivity_follow_up: this.sendInactivityFollowUp,
          inactivity_follow_up_minutes: this.convertUnits(this.inactivityFollowUpMinutes, this.inactivityFollowUpUnit),
          inactivity_follow_up_unit: this.convertUnitToString(this.inactivityFollowUpUnit),
          show_username_on_chat: this.showUsernameOnChat,
          unify_connections: this.unifyConnections,
          relate_chat_tickets_to_next_user: !this.relateChatTicketsToNextUser,
          older_inbox_chats_first_only: this.olderInboxChatsFirstOnly,
          older_inbox_chats_obligatorie_in_first: this.olderInboxChatsObligatorieInFirst,
          limit_chat_tickets_activated: this.relateChatTicketsToNextUser === true ? this.limitChatTicketsActivated : false,
          limit_chat_tickets: this.limitChatTickets,
          send_report_every_day: this.sendReportEveryDay,
          send_order_status_notification: this.sendOrderStatusNotification,
          email: JSON.stringify(this.emails),
          medications_options_is_disabled: this.medicationsOptionsIsDisabled,
          enable_negative_stock: this.enableNegativeStock,
          always_send_new_passive_flow: this.alwaysSendNewPassiveFlow,
          send_triage_flow: this.sendTriageFlow,
          send_sale_flow: this.sendSaleFlow,
          allow_delivery_option_sale_flow: this.allowDeliveryOptionSaleFlow,
          expiration_password: this.expirationPassword,
          date: this.date,
          time: this.time,
          selected: this.selected
        }).then(() => {
          this.$vs.notify({
            color: 'success',
            title: 'Sucesso!',
            text: 'Suas configurações foram salvas com sucesso.'
          })
        }).catch((error) => {
          console.log(error)
          this.$vs.notify({
            color: 'danger',
            title: 'Ocorreu um erro ao salvar as configurações!',
            text: 'Sentimos muito, um erro ocorreu, por favor, nos contate para corrigir!'
          })
        })
      },
      setSettingsValues() {
        const {
          notifications_phone_number,
          spam_interval_messages,
          spam_interval_minutes,
          // use_chat_flow,
          send_campaign_to_all,
          resend_failed_dispatches,
          spam_resend_failed_dispatches,
          block_customers_all_instances,
          redirect_idle_minutes,
          request_transfer_minutes,
          always_send_passive_flow,
          alloy_sleep_passive_flow,
          enable_back_option_passive_flow,
          priority_tickets_in_passive_flow,
          priority_without_passive_flow,
          priority_without_passive_flow_minutes,
          reply_customer_chat_option_choose,
          send_message_LGPD_in_flow,
          disconnect_all_chats_at_midnight,
          disconnect_all_search_at_midnight,
          finish_chat_tickets_by_inactivity,
          finish_chat_tickets_by_inactivity_minutes,
          finish_chat_tickets_by_inactivity_unit,
          finish_chat_tickets_by_inbox_inactivity,
          finish_chat_tickets_by_inbox_inactivity_minutes,
          finish_chat_tickets_by_inbox_inactivity_unit,
          send_inactivity_follow_up,
          inactivity_follow_up_minutes,
          inactivity_follow_up_unit,
          is_mandatory_research,
          unify_connections,
          send_report_every_day,
          send_order_status_notification,
          email,
          show_username_on_chat,
          relate_chat_tickets_to_next_user,
          older_inbox_chats_first_only,
          older_inbox_chats_obligatorie_in_first,
          limit_chat_tickets_activated,
          limit_chat_tickets,
          medications_options_is_disabled,
          enable_negative_stock,
          always_send_new_passive_flow,
          send_triage_flow,
          send_sale_flow,
          allow_delivery_option_sale_flow,
          expiration_password,
          date,
          time,
          selected
        } = this.settings;

        let formatedEmail;

        if (email && (email.startsWith('[') && email.endsWith(']'))) {
            formatedEmail = email ? JSON.parse(email) : ['']
        } else {
            formatedEmail = [email]
        }

        this.notificationsPhoneNumber = notifications_phone_number ? notifications_phone_number : '';
        this.spamIntervalMessages = spam_interval_messages ? spam_interval_messages : 2;
        this.spamIntervalMinutes = spam_interval_minutes ? spam_interval_minutes : 1;
        // this.useChatFlow = !!parseInt(use_chat_flow)
        this.unifyConnections = !!parseInt(unify_connections);
        this.sendCampaignToAll = !!parseInt(send_campaign_to_all);
        this.resendFailedDispatches = !!parseInt(resend_failed_dispatches);
        this.spamResendFailedDispatches = spam_resend_failed_dispatches ? spam_resend_failed_dispatches : 1;
        this.blockCustomersAllInstances = !!parseInt(block_customers_all_instances);
        this.redirectIdleAttendance = !!parseInt(redirect_idle_minutes);
        this.redirectIdleMinutes = redirect_idle_minutes ? redirect_idle_minutes : 2;
        this.alwaysSendPassiveFlow = !!parseInt(always_send_passive_flow);
        this.alloySleepPassiveFlow = !!parseInt(alloy_sleep_passive_flow);
        this.enableBackOptionPassiveFlow = !!parseInt(enable_back_option_passive_flow);
        this.priorityTicketsInPassiveFlow = !!parseInt(priority_tickets_in_passive_flow);
        this.priorityWithoutPassiveFlow = !!parseInt(priority_without_passive_flow);
        this.priorityWithoutPassiveFlowMinutes = priority_without_passive_flow_minutes ? priority_without_passive_flow_minutes : 10;
        this.replyCustomerChatOptionChoose = !!parseInt(reply_customer_chat_option_choose);
        this.sendMessageLGPDInFlow = !!parseInt(send_message_LGPD_in_flow);
        this.requestTransferMinutes = request_transfer_minutes ? request_transfer_minutes : 1;
        this.disconnectAllChatsAtMidnight = !!parseInt(disconnect_all_chats_at_midnight);
        this.disconnectAllSearchAtMidnight = !!parseInt(disconnect_all_search_at_midnight);
        this.finishChatTicketsByInactivity = !!parseInt(finish_chat_tickets_by_inactivity);
        this.finishChatTicketsByInactivityMinutes = this.convertUnits(finish_chat_tickets_by_inactivity_minutes, finish_chat_tickets_by_inactivity_unit, false);
        this.selectedUnit = this.convertUnitToString(finish_chat_tickets_by_inactivity_unit, false);
        this.finishChatTicketsByInboxInactivity = !!parseInt(finish_chat_tickets_by_inbox_inactivity);
        this.finishChatTicketsByInboxInactivityMinutes = this.convertUnits(finish_chat_tickets_by_inbox_inactivity_minutes, finish_chat_tickets_by_inbox_inactivity_unit, false);
        this.inboxInactivitySelectUnit = this.convertUnitToString(finish_chat_tickets_by_inbox_inactivity_unit, false);
        this.isMandatoryResearch = !!parseInt(is_mandatory_research);
        this.showUsernameOnChat = !!parseInt(show_username_on_chat);
        this.relateChatTicketsToNextUser = !(relate_chat_tickets_to_next_user === undefined || !!parseInt(relate_chat_tickets_to_next_user));
        this.olderInboxChatsFirstOnly = !!parseInt(older_inbox_chats_first_only);
        this.olderInboxChatsObligatorieInFirst = !!parseInt(older_inbox_chats_obligatorie_in_first);
        this.limitChatTicketsActivated = !!parseInt(limit_chat_tickets_activated);
        this.limitChatTickets = limit_chat_tickets ? limit_chat_tickets : 0;
        this.sendReportEveryDay = !!parseInt(send_report_every_day);
        this.sendOrderStatusNotification = !!parseInt(send_order_status_notification);
        this.emails = formatedEmail;
        this.medicationsOptionsIsDisabled = !!parseInt(medications_options_is_disabled);
        this.enableNegativeStock = !!parseInt(enable_negative_stock);
        this.alwaysSendNewPassiveFlow = !!parseInt(always_send_new_passive_flow);
        this.sendTriageFlow = !!parseInt(send_triage_flow);
        this.sendSaleFlow = !!parseInt(send_sale_flow);
        this.allowDeliveryOptionSaleFlow = !!parseInt(allow_delivery_option_sale_flow);
        this.expirationPassword = !!parseInt(expiration_password);
        this.date = date ? date : '';
        this.time = time ? time : '';
        this.selected = selected ? selected : '';
        this.sendInactivityFollowUp = !!parseInt(send_inactivity_follow_up);
        this.inactivityFollowUpMinutes = this.convertUnits(inactivity_follow_up_minutes, inactivity_follow_up_unit, false);
        this.inactivityFollowUpUnit = this.convertUnitToString(inactivity_follow_up_unit, false);
        this.setMariaType();

        ( this.alwaysSendPassiveFlow || this.alwaysSendNewPassiveFlow )
        ? this.botIsActive = true
        : this.botIsActive = false;
      },
      canSee(resource) {
        return hasPermission(resource)
      },
      handleStyle(target, sibbling, value) {
        if (value) {
          target.style.maxHeight = 'fit-content';
          sibbling.style.position = 'unset';
        }
        else {
          target.style.maxHeight = '60px';
          sibbling.style.position = 'relative';
          sibbling.style.bottom = '5px';
        }
      },
      formatToInternationalDate(date) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      calculateNewDate() {
        if (this.expirationPassword === true) {
          const selectElement = document.getElementById('period');
          const selectedValue = parseInt(selectElement.value);

          if (!isNaN(selectedValue)) {
            const currentDate = new Date();
            let newDate;

            switch (selectedValue) {
              case 1:
                newDate = new Date(currentDate.getTime() + selectedValue * 24 * 60 * 60 * 1000);
                break;
              case 7:
                newDate = new Date(currentDate.getTime() + selectedValue * 24 * 60 * 60 * 1000);
                break;
              case 30:
                newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, currentDate.getDate());
                break;
              case 90:
                newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 3, currentDate.getDate());
                break;
              case 180:
                newDate = new Date(currentDate.getFullYear(), currentDate.getMonth() + 6, currentDate.getDate());
                break;
              case 365:
                newDate = new Date(currentDate.getFullYear() + 1, currentDate.getMonth(), currentDate.getDate());
                break;
              default:
                return;
            }

            const formattedDate = this.formatToInternationalDate(newDate);
            const [date, time] = formattedDate.split(' ');

            this.date = date;
            this.time = time;
          }
        } else {
          return;
        }
      },
      handleMariaType(value) {
        const evalType = ( id ) => {
          function* up() {
            yield 1;
            yield 2;
            yield null;
          }

          const counter = up();

          if (id == counter.next().value || id == null) {
            return [
              this.sendTriageFlow,
              this.sendSaleFlow
            ] = [ true, false ];
          }

          if (id == counter.next().value) {
            return [
              this.sendTriageFlow,
              this.sendSaleFlow
            ] = [ false, true ];
          }
        }

        evalType(value);
      },
      setMariaType() {
        if (!this.sendTriageFlow && !this.sendSaleFlow || this.sendTriageFlow && !this.sendSaleFlow) {
          return this.mariaType = 1;
        }

        return this.mariaType = 2;
      },
      removeEmail(index) {
        this.emails.splice(index, 1)
      },
      convertUnits(minutes, unit, update = true) {
        if (!update) {
          return minutes ? unit === "0" ? minutes : unit === "1" ? minutes / 60 : unit === "2" ? minutes / 1440 : minutes : 1;
        }
        return (minutes && unit === "Horas") ? minutes * 60 : (minutes && unit === "Dias") ? minutes * 1440 : minutes;
      },
      convertUnitToString(unit, update = true) {
        if (!update) {
          return unit === "0" ? "Minutos" : unit === "1" ? "Horas" : unit === "2" ? "Dias" : null;
        }
        return unit === "Minutos" ? 0 : unit === "Horas" ? 1 : unit === "Dias" ? 2 : null;
      }
    },
    async mounted() {
      this.mariaIsEnabled = await hasFeature('maria');

      if (!moduleSettings.isRegistered) {
        this.$store.registerModule('settings', moduleSettings)
        moduleSettings.isRegistered = true
      }
      
      this.$store.dispatch("settings/fetch")
        .then(() => {
          this.setSettingsValues()
        })
        setTimeout(() => {
          if (
            parseInt(this.finishChatTicketsByInactivityMinutes) > 59 && parseInt(this.finishChatTicketsByInactivityMinutes) <= 1439 && this.selectedUnit === "Minutos" ||
            parseInt(this.inactivityFollowUpMinutes) > 59 && parseInt(this.inactivityFollowUpMinutes) <= 1439 && this.inactivityFollowUpUnit === "Minutos" ||
            parseInt(this.finishChatTicketsByInboxInactivityMinutes) > 59 && parseInt(this.finishChatTicketsByInboxInactivityMinutes) <= 1439 && this.inboxInactivitySelectUnit === "Minutos"
          ) {
            this.$store.dispatch("settings/update", {
              spam_interval_messages: this.spamIntervalMessages,
              spam_interval_minutes: this.spamIntervalMinutes,
              spam_interval_limit: this.spamIntervalLimit,
              // use_chat_flow: this.useChatFlow,
              notifications_phone_number: this.notificationsPhoneNumber,
              send_campaign_to_all: this.sendCampaignToAll,
              resend_failed_dispatches: this.resendFailedDispatches,
              spam_resend_failed_dispatches: this.spamResendFailedDispatches,
              block_customers_all_instances: this.blockCustomersAllInstances,
              redirect_idle_minutes: this.redirectIdleMinutes,
              request_transfer_minutes: this.requestTransferMinutes,
              always_send_passive_flow: this.alwaysSendPassiveFlow,
              alloy_sleep_passive_flow: this.alloySleepPassiveFlow,
              enable_back_option_passive_flow: this.enableBackOptionPassiveFlow,
              priority_tickets_in_passive_flow: this.priorityTicketsInPassiveFlow,
              priority_without_passive_flow: this.priorityWithoutPassiveFlow,
              priority_without_passive_flow_minutes: this.priorityWithoutPassiveFlowMinutes,
              reply_customer_chat_option_choose: this.replyCustomerChatOptionChoose,
              send_message_LGPD_in_flow: this.sendMessageLGPDInFlow,
              disconnect_all_chats_at_midnight: this.disconnectAllChatsAtMidnight,
              disconnect_all_search_at_midnight: this.disconnectAllSearchAtMidnight,
              finish_chat_tickets_by_inactivity: this.finishChatTicketsByInactivity,
              finish_chat_tickets_by_inactivity_minutes: this.convertUnits(this.finishChatTicketsByInactivityMinutes, this.selectedUnit),
              finish_chat_tickets_by_inactivity_unit: "1",
              finish_chat_tickets_by_inbox_inactivity: this.finishChatTicketsByInboxInactivity,
              finish_chat_tickets_by_inbox_inactivity_minutes: this.convertUnits(this.finishChatTicketsByInboxInactivityMinutes, this.inboxInactivitySelectUnit),
              finish_chat_tickets_by_inbox_inactivity_unit: "1",
              send_inactivity_follow_up: this.sendInactivityFollowUp,
              inactivity_follow_up_minutes: this.convertUnits(this.inactivityFollowUpMinutes, this.inactivityFollowUpUnit),
              inactivity_follow_up_unit: "1",
              is_mandatory_research: this.isMandatoryResearch,
              show_username_on_chat: this.showUsernameOnChat,
              unify_connections: this.unifyConnections,
              relate_chat_tickets_to_next_user: !this.relateChatTicketsToNextUser,
              older_inbox_chats_first_only: this.olderInboxChatsFirstOnly,
              older_inbox_chats_obligatorie_in_first: this.olderInboxChatsObligatorieInFirst,
              limit_chat_tickets_activated: this.relateChatTicketsToNextUser === true ? this.limitChatTicketsActivated : false,
              limit_chat_tickets: this.limitChatTickets,
              send_report_every_day: this.sendReportEveryDay,
              send_order_status_notification: this.sendOrderStatusNotification,
              email: JSON.stringify(this.emails),
              medications_options_is_disabled: this.medicationsOptionsIsDisabled,
              enable_negative_stock: this.enableNegativeStock,
              always_send_new_passive_flow: this.alwaysSendNewPassiveFlow,
              send_triage_flow: this.sendTriageFlow,
              send_sale_flow: this.sendSaleFlow,
              allow_delivery_option_sale_flow: this.allowDeliveryOptionSaleFlow,
              expiration_password: this.expirationPassword,
              date: this.date,
              time: this.time,
              selected: this.selected
            }).then(() => {
              this.$store.dispatch("settings/fetch")
              .then(() => {
                this.setSettingsValues()
            })
          })
        }
      }, 2000);
    },
    beforeRouteLeave(to, from, next) {
      this.infosIsActive = false;
      setTimeout( () => next(), 2 );
    }
  }
</script>

<style lang="scss">
#tooltip {
  transform: translateY(-0.2em);
}

#adjustment-root .flex-direction-column {
  flex-direction: column !important;
}

#adjustment-root .flex-direction-row {
  flex-direction: row !important;
}

#adjustment-root .con-vs-card {
  margin: 8px;
}
#adjustment-root div:nth-child(1) {
  > header > div > h5 > div > div button,
  > div:nth-child(2) > div > div:nth-child(2) > div > div.w-full.blue-button > div > button {
    background-color: #0491ff;
  }
}
#adjustment-root .flex.flex-direction-row.w-full.justify-left.items-center {
  height: 35px;
}

#content-area {
  > div.content-wrapper > div > div > div.content-area__content > div:nth-child(2) 
    > div.flex.flex-direction-column.flex.justify-center.mb-8.items-center > div:nth-child(1) > div {
      > div:nth-child(1),
      > div:nth-child(2) {
        max-height: 60px;
    }
  }
}

#content-area > div.content-wrapper > div > div > div.content-area__content > div:nth-child(2) > div.flex.flex-direction-column.flex.justify-center.mb-8.items-center > div:nth-child(2) > div > div:nth-child(1) {
  bottom: 60px;
}

@media (max-width: 550px) {
  #adjustment-root div.flex.flex-direction-column.flex.justify-center.mb-8.items-center > div:nth-child(1) > div > div:nth-child(1) > header > div > h5 > div > div {
    display: block !important;
    text-align: center;
  }
  #adjustment-root .con-vs-checkbox.items-center {
    display: block;
    text-align: center;
  }
  #content-area > div.content-wrapper.mt-16 > div > div > div.content-area__content > div:nth-child(2) > div.flex.flex-direction-column.flex.justify-center.mb-8.items-center > div:nth-child(1) > div > div:nth-child(1) > header > div > h5 > div > div > button {
    margin-left: 35% !important;
  }
}
@media (max-width: 812px) {
  #content-area > div.content-wrapper.mt-16 > div > div > div.content-area__content > div:nth-child(2) > div.flex.flex-direction-column.flex.justify-center.mb-8.items-center > div:nth-child(1) > div > div:nth-child(1) {
    min-height: 90px !important;
  }
}
@media (max-width: 550px) {
  #content-area > div.content-wrapper.mt-16 > div > div > div.content-area__content > div:nth-child(2) > div.flex.flex-direction-column.flex.justify-center.mb-8.items-center > div:nth-child(1) > div > div:nth-child(1) {
    min-height: 120px !important;
  }
}
@media (max-width: 517px) {
  #content-area > div.content-wrapper.mt-16 > div > div > div.content-area__content > div:nth-child(2) > div.flex.flex-direction-column.flex.justify-center.mb-8.items-center > div:nth-child(1) > div > div:nth-child(1) {
    min-height: 140px !important;
  }
}
.align-input-date-time {
  display: flex;
  margin-top: 10px;
}
.custom-select {
  position: relative;
  width: 100%;
}
.custom-select-font{
  font-size: 50px;
  color: #333;
}

.select-maria-type {
  max-width: 50%;
  margin: 5px 0 0 5px;
}

.custom-select select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-color: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 38px;
  padding: 8px;
  cursor: pointer;
  outline: none;
  margin-left: 12px;
}

.custom-select select:focus {
  border-color: #007BFF;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.4);
}

</style>